// extracted by mini-css-extract-plugin
export var addButton = "_g3-0";
export var border = "_g3-8";
export var check = "_g3-h";
export var danger = "_g3-6";
export var dropdownContainer = "_g3-1";
export var editModalBody = "_g3-j";
export var footerContainer = "_g3-i";
export var fullWidth = "_g3-a";
export var hide = "_g3-9";
export var icon = "_g3-3";
export var input = "_g3-7";
export var inputFlex = "_g3-b";
export var inputWrapper = "_g3-c";
export var manualFocus = "_g3-5";
export var optionButton = "_g3-4";
export var pillWrapper = "_g3-e";
export var pointer = "_g3-2";
export var showOverflow = "_g3-f";
export var tagsFlex = "_g3-d";
export var xButton = "_g3-g";